import { render, staticRenderFns } from "./SpecimenCopyForm.vue?vue&type=template&id=49441fe9&lang=pug"
import script from "./SpecimenCopyForm.vue?vue&type=script&lang=js"
export * from "./SpecimenCopyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports